import { defineComponent as Y, useAttrs as G, computed as a, ref as J, toRef as K, createElementBlock as h, openBlock as d, mergeProps as I, withDirectives as Q, createCommentVNode as p, renderSlot as X, createElementVNode as Z, toHandlers as ee, unref as f, normalizeClass as y, toDisplayString as x, createBlock as z, resolveDynamicComponent as te, toRaw as ae } from "vue";
import { RevButtonIcon as le } from "@ds/components/ButtonIcon";
import { useNativeInput as oe } from "../../composables/useNativeInput.js";
import { vFocus as ie } from "../../directives/focus.js";
import se from "../../icons/generated/IconCrossInCircle.vue2.js";
import { useI18n as ue } from "@ds/plugin";
import re from "../../translations/generic.translations.js";
import { isEmpty as B } from "../../utils/isEmpty.js";
import { omit as ne } from "../../utils/omit.js";
import { tw as e } from "../../utils/tailwind.js";
import { TYPES_WITH_DEFAULT_PLACEHOLDER as de } from "./InputText.constant.js";
const ce = ["disabled", "required", "value"], ve = ["for"], pe = ["id", "role"], Te = /* @__PURE__ */ Y({
  name: "RevInputText",
  inheritAttrs: !1,
  __name: "InputText",
  props: {
    autofocus: { type: Boolean, default: !1 },
    clearButtonAriaLabel: { default: void 0 },
    description: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    format: { type: Function, default: (g) => g },
    hasClearButton: { type: Boolean, default: !0 },
    helperTextClass: { type: [String, Boolean, Array, Object], default: e`mt-8` },
    icon: { default: void 0 },
    id: {},
    inputClass: { type: [String, Boolean, Array, Object], default: e`` },
    label: {},
    modelValue: {},
    size: { default: "medium" },
    type: { default: "text" },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "invalid", "valid", "clear"],
  setup(g, { expose: N, emit: D }) {
    const l = g, r = D, m = G(), E = a(
      () => ne(m, ["class", "style"])
    ), L = a(() => ({
      class: m.class,
      style: m.style
    })), s = J(null), b = oe(s, K(l, "modelValue"), {
      onInput: (t) => {
        const i = l.format(t.target.value);
        s.value && (s.value.value = String(i)), r("update:modelValue", i), r("input", t);
      },
      onValidityChange: (t) => {
        var i, A;
        t ? r("valid") : r(
          "invalid",
          (i = s.value) == null ? void 0 : i.validity,
          ((A = s.value) == null ? void 0 : A.validationMessage) ?? ""
        );
      }
    }), S = () => {
      var t;
      r("input", {
        target: {
          value: ""
        }
      }), r("update:modelValue", ""), r("clear"), (t = s.value) == null || t.focus();
    }, o = a(() => l.size === "small"), c = a(() => !B(l.error)), C = a(
      () => typeof l.modelValue == "string" ? !B(l.modelValue) : !(typeof l.modelValue > "u")
    ), u = a(
      () => c.value || b.touched.value && b.invalid.value
    ), _ = a(
      () => l.type ? de.includes(l.type) : !1
    ), F = a(() => !B(m.placeholder)), q = a(() => !(o.value && C.value)), w = a(
      () => !o.value && (b.focused.value || _.value || C.value || F.value)
    ), n = a(
      () => !o.value && l.hasClearButton && C.value
    ), v = a(
      () => !o.value && !!l.icon && !n.value
    ), V = a(() => o.value ? "" : u.value && c.value ? l.error : l.description), T = a(() => {
      if (u.value)
        return u.value && `${l.id}_error`;
    }), P = a(
      () => ({
        ...E.value,
        id: l.id,
        type: l.type,
        "aria-label": l.label,
        ...u.value ? { "aria-invalid": "true" } : {},
        ...c.value ? { "aria-describedby": T.value } : {}
      })
    ), R = ue(), O = l.clearButtonAriaLabel || R(re.buttonClear);
    N({
      input: s
    });
    const k = a(() => (t) => {
      const i = e`motion-safe:transition-colors motion-safe:duration-200`;
      return o.value ? [
        i,
        e`bg-action-default-mid`,
        t && e`peer-hover:bg-action-default-mid-hover peer-disabled:bg-action-default-mid-disabled`,
        !t && e`hover:bg-action-default-mid-hover disabled:bg-action-default-mid-disabled`
      ] : [
        i,
        e`bg-static-default-low`,
        t && e`peer-hover:bg-static-default-low-hover peer-disabled:bg-transparent`,
        !t && e`hover:bg-static-default-low-hover disabled:bg-static-default-low-disabled`
      ];
    }), H = a(() => [
      e`peer rounded-sm input-normalize relative w-full min-w-0 pl-12`,
      l.inputClass,
      k.value(!1),
      o.value ? [
        e`h-32 border-none disabled:text-onaction-default-mid-disabled`,
        u.value ? e`text-onaction-danger-mid` : e`text-onaction-default-mid`
      ] : [
        e`text-action-default-hi input-normalize h-48 border border-solid disabled:border-action-default-low-disabled disabled:text-action-default-hi-disabled`,
        u.value ? e`border-action-danger-low focus-visible:border-action-danger-low-focus` : e`border-action-default-low focus-visible:border-action-default-low-focus`
      ],
      u.value ? e`focus-visible-outline-danger-low` : e`focus-visible-outline-default-low`,
      w.value && e`pt-14`,
      n.value && e`pr-48 type-date:pr-8`,
      v.value && e`pr-44 type-date:pr-8`,
      !n.value && !v.value && e`pr-12`
    ]), $ = a(() => [
      e`relative`,
      o.value ? e`body-1-bold` : e`body-1`
    ]), j = a(() => [
      e`body-2 flex items-baseline peer-disabled:text-static-default-low-disabled`,
      l.helperTextClass,
      c.value ? e`text-static-danger-hi` : e`text-static-default-low`
    ]), M = a(() => [
      o.value && e`text-onaction-default-mid body-1-bold top-16`,
      o.value && c.value && e`text-onaction-danger-mid`,
      w.value && e`text-static-default-low caption top-5 transform-none`,
      !w.value && !o.value && e`text-action-default-hi body-1 top-24`,
      n.value && e`pr-36`,
      v.value && e`pr-32`,
      e`pointer-events-none absolute left-[calc(0.75rem+1px)] right-12 z-[inherit]`,
      e`max-w-full`,
      e`-translate-y-1/2 truncate peer-disabled:text-onaction-default-mid-disabled`,
      e`motion-safe:transition-all motion-safe:duration-200`
    ]), W = a(() => [
      e`rounded-sm pointer-events-none absolute right-4 top-4 z-[1] size-40`,
      k.value(!0)
    ]), U = a(() => [
      e`pointer-events-none absolute right-10 z-[1] h-40`,
      l.disabled ? e`text-static-default-low-disabled` : e`text-static-default-low`
    ]);
    return (t, i) => (d(), h("div", I(L.value, { class: $.value }), [
      Q(Z("input", I({
        ref_key: "input",
        ref: s
      }, P.value, {
        class: H.value,
        "data-test": "input-text-input",
        disabled: t.disabled,
        required: t.required,
        value: t.format(t.modelValue)
      }, ee(f(b).listeners, !0)), null, 16, ce), [
        [f(ie), t.autofocus]
      ]),
      q.value ? (d(), h("label", {
        key: 0,
        class: y(M.value),
        for: t.id
      }, x(t.label) + x(t.required ? " *" : ""), 11, ve)) : p("", !0),
      n.value || v.value ? (d(), h("div", {
        key: 1,
        class: y(W.value)
      }, [
        n.value ? (d(), z(f(le), {
          key: 0,
          "aria-label": f(O),
          class: "pointer-events-auto absolute disabled:pointer-events-none",
          "data-test": "clear-button",
          disabled: t.disabled,
          icon: f(se),
          type: "button",
          variant: "secondary",
          onClick: S
        }, null, 8, ["aria-label", "disabled", "icon"])) : p("", !0),
        v.value ? (d(), z(te(ae(t.icon)), {
          key: 1,
          "aria-hidden": "true",
          class: y(U.value),
          "data-test": "icon",
          size: "20"
        }, null, 8, ["class"])) : p("", !0)
      ], 2)) : p("", !0),
      X(t.$slots, "default"),
      V.value ? (d(), h("p", {
        key: 2,
        id: T.value,
        "aria-live": "assertive",
        class: y(j.value),
        role: u.value ? "alert" : void 0
      }, x(V.value), 11, pe)) : p("", !0)
    ], 16));
  }
});
export {
  Te as default
};
